// ABOUTME: dnd-kit wrapper around a single news article section providing reorder behaviour.
// ABOUTME: Children fill the row; drag handle sits on the right rail and reveals on hover.

import { Box, IconButton } from "@mui/material";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

const SortableArticleSection = ({ id, colors, children }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: String(id) });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1,
    };

    return (
        <Box
            ref={setNodeRef}
            style={style}
            sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1,
                "&:hover .drag-handle": {
                    opacity: 1,
                },
            }}
        >
            <Box sx={{ flex: 1, minWidth: 0 }}>
                {children}
            </Box>
            <IconButton
                className="drag-handle"
                {...attributes}
                {...listeners}
                disableRipple
                sx={{
                    mt: 0.5,
                    width: 24,
                    height: 24,
                    opacity: 0,
                    transition: "opacity 150ms",
                    color: colors.txt["secondary"],
                    cursor: "grab",
                    "&:active": { cursor: "grabbing" },
                    "&:hover": { color: colors.txt["primary"], background: "transparent" },
                }}
            >
                <DragIndicatorIcon sx={{ fontSize: 18 }} />
            </IconButton>
        </Box>
    );
};

export default SortableArticleSection;
